import { c as _c } from "react/compiler-runtime";
import { Autocomplete } from '@base-ui/react/autocomplete';
import type { SearchResultItem, SearchResultSource } from '../../../search.types';
import { SearchResultGroup } from './search-result-group';
type SearchResultsProps = {
  onResult: (result: SearchResultItem) => void;
  query: string;
  sources: readonly SearchResultSource[];
};
export function SearchResults(t0) {
  const $ = _c(9);
  const {
    onResult,
    query,
    sources
  } = t0;
  let t1;
  if ($[0] !== onResult || $[1] !== query || $[2] !== sources) {
    let t2;
    if ($[4] !== onResult || $[5] !== query) {
      t2 = source => <SearchResultGroup key={source.kind} onResult={onResult} query={query} source={source} />;
      $[4] = onResult;
      $[5] = query;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = sources.map(t2);
    $[0] = onResult;
    $[1] = query;
    $[2] = sources;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <Autocomplete.List className="header-search__list" render={_temp}>{t1}</Autocomplete.List>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(props) {
  const listProps = {
    ...props
  };
  delete listProps["aria-orientation"];
  return <div {...listProps} />;
}